/* ============================================================================
   section-bd-finder.js — hover preview for the finder (V3).
   On entry hover (desktop), show the entry's preview image(s) pinned to the
   top-right of its column, near the hovered row. Pure enhancement: without JS
   the entries are plain working links; preview is hidden on mobile by CSS.
   ============================================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function wire(card) {
    if (card.dataset.bdFinderReady) return;
    card.dataset.bdFinderReady = '1';
    var preview = card.querySelector('.bd-finder__preview');
    var list = card.querySelector('.bd-finder__list');
    if (!preview || !list) return;

    list.querySelectorAll('a[data-preview]').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        var srcs = [
          [a.getAttribute('data-preview'), a.getAttribute('data-preview-alt') || ''],
          [a.getAttribute('data-preview2'), a.getAttribute('data-preview2-alt') || '']
        ].filter(function (p) { return p[0]; });
        if (!srcs.length) return;
        preview.innerHTML = srcs.map(function (p) {
          return '<img class="bd-fp-img" src="' + p[0] + '" alt="' +
            p[1].replace(/"/g, '&quot;') + '" loading="lazy">';
        }).join('');
        preview.style.top = Math.max(4, a.offsetTop - 36) + 'px';
        card.classList.add('is-preview');
      });
    });
    list.addEventListener('mouseleave', function () {
      card.classList.remove('is-preview');
    });
  }

  function boot() {
    document.querySelectorAll('.bd-finder__card').forEach(wire);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
